import { Route, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FeatureFlags } from '@core/enumeration/featureFlags';
import { CreateAuthPacGuard, FeatureToggleGuard } from '@core/guards';
import { RouterFragments } from '@core/model/RouterFragments';
import { PortalProducts } from '@shared/enumeration';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { authDetailsTitleResolver } from '@core/resolvers/auth-details-title.resolver';
import { ProviderDashboardComponent } from '../pages/provider-dashboard/provider-dashboard.component';

export default [
  {
    path: `:tenantId/pac-im/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () =>
      import(
        '@pages/auth-detail-not-found/auth-detail-not-found.module'
      ).then((m) => m.AuthDetailNotFoundModule),
    title: 'Auth Details Not Found',
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: `:tenantId/pac-commercial/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () => import('@pages/auth-detail-not-found/auth-detail-not-found.module').then((m) => m.AuthDetailNotFoundModule),
    title: 'Auth Details Not Found',
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PACIM}/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@pages/auth-details-pacim-view/auth-details-pacim-view.module').then((m) => m.AuthDetailsPacimViewModule),
    title: authDetailsTitleResolver('Auth Details'),
    data: {
      permissions: ['PACIMAuthorization.Read'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PacCommercial}/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@pages/auth-details-pac-commercial/auth-details-pac-commercial.module').then((m) => m.AuthDetailsPacCommercialModule),
    title: authDetailsTitleResolver('Auth Details'),
    data: {
      permissions: ['PACIMAuthorization.Read'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PACIM}/continued-stay/:authorizationNumber`,
    loadChildren: () => import('@pages/continued-stay-pac/continued-stay-pac.module').then((m) => m.ContinuedStayPacModule),
    title: 'Continued Stay Request',
    data: {
      permissions: ['ContinuedStayRequest.Create'],
      productName: PortalProducts.PACIM
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PacCommercial}/continued-stay/:authorizationNumber`,
    loadChildren: () => import('@pages/continued-stay-pac/continued-stay-pac.module').then((m) => m.ContinuedStayPacModule),
    title: 'Continued Stay Request',
    data: {
      permissions: ['ContinuedStayRequest.Create'],
      productName: PortalProducts.PacCommercial
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: ':tenantId/pac-im/member/:memberId/request-initial',
    loadChildren: () => import('@pages/auth-request-pacim-initial/auth-request-pacim-initial.module')
      .then((m) => m.AuthRequestPacImInitialModule),
    title: 'Authorization Request',
    data: {
      permissions: ['PACIMAuthorization.Create'],
      featureAccess: FeatureFlags.PACIM,
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      FeatureToggleGuard,
      AccessPageGuard,
      CreateAuthPacGuard,
    ]),
  },
  {
    path: ':tenantId/pac-im/member/:memberId/request-pending/recommendation/:recommendationId',
    loadChildren: () => import('@pages/auth-request-pending/auth-request-pending.module')
      .then((m) => m.AuthRequestPendingModule),
    title: 'Authorization Request',
    data: {
      permissions: ['PendingRequest.Read'],
      featureAccess: FeatureFlags.PACPendingRequestDashboard,
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      FeatureToggleGuard,
      AccessPageGuard,
    ]),
  },
  {
    path: ':tenantId/pac-commercial/member/:memberId/request-initial',
    loadChildren: () =>
      import(
        '@pages/auth-request-pac-commercial/auth-request-pac-commercial.module'
      ).then((m) => m.AuthRequestPacCommercialModule),
    title: 'Authorization Request',
    data: {
      permissions: ['PACIMAuthorization.Create'],
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      AccessPageGuard,
      CreateAuthPacGuard,
    ]),
  },
  {
    path: ':tenantId/provider-dashboard',
    component: ProviderDashboardComponent,
    title: 'Provider Dashboard',
    data: {
      permissions: ['ProviderDashboard.Read'],
    },
    canActivate: mapToCanActivate([AccessPageGuard]),
  },
  {
    path: ':tenantId/pending-requests-dashboard',
    loadChildren: () => import('@pages/pending-requests-dashboard/pending-requests-dashboard.module')
      .then((m) => m.PendingRequestsDashboardModule),
    title: 'Pending Requests Dashboard',
    data: {
      permissions: ['PendingRequest.Read'],
      featureAccess: FeatureFlags.PACPendingRequestDashboard,
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard, FeatureToggleGuard]),
  },
] as Route[];
